// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"397f78bc","239":"4a84187b","455":"a9d9b04b"}[chunkId] + ".chunk.js";
};